// MIT License
// Based on https://github.com/ClaudiuCeia/detect-translation

import { makeOnce } from "@warrenio/utils/makeOnce";
import { entries } from "remeda";

// cSpell:disable
const SELECTORS = {
    microsoft: "[_msthash],[_msttexthash]",
    google: '[href^="https://translate.googleapis.com"],#goog-gt-tt,.goog-te-spinner-pos',
    tencent: "#qbTrans-pageTrans-dialog,[class^=qbTrans-pageTrans-dialog]",
    sogou: '[class^="sg-trans"]',
    yandex: "ya-tr-span",
};
// cSpell:enable

function detectTranslation(): keyof typeof SELECTORS | undefined {
    const [service] = entries(SELECTORS).find(([, selector]) => document.querySelector(selector)) ?? [];
    return service;
}

export const detectTranslationOnce = makeOnce(detectTranslation);
